import { Component, inject, OnInit } from '@angular/core';
import { IntegrationService } from '../../../../_services/integration.service';
import { MerchantService } from '../../../../_services/merchant.service';
import { EndPoints } from '../../test-area/configurations/configurations-solutions/configurations-solutions.component';
import { ConfigurationService } from '../../../../_services/configuration.service';

@Component({
  selector: 'app-prod-configurations-solutions',
  templateUrl: './prod-configurations-solutions.component.html',
  styleUrls: ['./prod-configurations-solutions.component.scss'],
  standalone: false
})
export class ProdConfigurationsSolutionsComponent implements OnInit {
  private readonly integrationService: IntegrationService = inject(IntegrationService);
  private readonly merchantService: MerchantService = inject(MerchantService);
  private readonly configurationService: ConfigurationService = inject(ConfigurationService);

  currentMerchant: any;
  qry: Array<object>;
  accessEndpoint: string;
  merchantID: string;
  productionLicense: any;
  productionMerchantsLicense: any;
  host: string = '{{host_production}}';
  displayedColumnsProduction = { soluzione: $localize`:@@th-Solution:Soluzioni`, collaudo: $localize`:@@th-Production:Produzione`, };
  endpointsProduction: EndPoints[] = [
    { soluzione: 'API Checkout', collaudo: { url: `${this.host}`, icon: 'open-in-new-tab' } },
    { soluzione: 'EASY', collaudo: { url: `${this.host}/sdk`, icon: 'open-in-new-tab' } },
    { soluzione: 'SMART', collaudo: { url: `${this.host}/sdk`, icon: 'open-in-new-tab' } },
    { soluzione: 'In-App IOS', collaudo: { url: `${this.host}`, icon: 'open-in-new-tab' } },
    { soluzione: 'In-App ANDROID', collaudo: { url: `${this.host}`, icon: 'open-in-new-tab' } }
  ];


  constructor() {
    this.setHost();
    this.configurationService.accessEnv$.subscribe((env) => {
      this.accessEndpoint = env;
    });
  }

  ngOnInit(): void {
    this.merchantID = this.merchantService.currentMerchant._id;
    this.qry = [{ key: 'merchant', value: this.merchantID }];
    this.integrationService.getProductionLicenseClean().subscribe((license: any) => this.productionMerchantsLicense = license.items);
  }

  setHost() {
    this.configurationService.getPublicSettings().subscribe((data: any) => {
      this.host = data?.settings?.host_production || this.host;
      this.endpointsProduction = [
        { soluzione: 'API Checkout', collaudo: { url: `${this.host}`, icon: 'open-in-new-tab' } },
        { soluzione: 'EASY', collaudo: { url: `${this.host}/sdk`, icon: 'open-in-new-tab' } },
        { soluzione: 'SMART', collaudo: { url: `${this.host}/sdk`, icon: 'open-in-new-tab' } },
        { soluzione: 'In-App IOS', collaudo: { url: `${this.host}`, icon: 'open-in-new-tab' } },
        { soluzione: 'In-App ANDROID', collaudo: { url: `${this.host}`, icon: 'open-in-new-tab' } }
      ];
    });
  }

  redirect() {
    const url = this.configurationService.normalizeAccessEndpoint(this.accessEndpoint, this.host);

    if (!this.accessEndpoint) console.log('no access endpoint found');
    window.open(url, '_blank');
  }

  setCurrentMerchant(currentMerchant) {
    this.currentMerchant = currentMerchant;
    this.productionLicense = currentMerchant.integrations;
    this.merchantService.currentProductionMerchant = currentMerchant;
  }

}
